module.exports = __webpack_public_path__ + "img/media_books.7fee5c1c.jpg";